<template>
	<nk-wrapper v-if="context.organisationseinheiten" spacing="md">
		<nk-accordion
			v-for="(
				organisationseinheit, organisationseinheitIndex
			) in context.organisationseinheiten"
			:key="organisationseinheitIndex"
			:title="organisationseinheit.name"
			:variant="nestingLevel > 0 ? 'default' : 'solid'"
			:title-size="nestingLevel > 0 ? 'lg' : 'md'"
			:open="openAccordion(organisationseinheitIndex)"
		>
			<nk-row vertical-gutter="2" gutter="2">
				<nk-col
					v-if="
						organisationseinheit.textbloecke &&
						organisationseinheit.textbloecke.find(
							textblock => textblock.typ === 'preamble',
						)
					"
					cols="full"
					md="auto"
				>
					<div
						class="nk-cms-content"
						v-html="
							organisationseinheit.textbloecke.find(
								textblock => textblock.typ === 'preamble',
							).text
						"
					/>
				</nk-col>
				<nk-col cols="full" md="shrink">
					<nk-button
						:link="`${
							context.taggingpfad.slice(-1) !== '/'
								? context.taggingpfad + '/'
								: context.taggingpfad
						}${
							$slugify(organisationseinheit.name) +
							'-id_' +
							organisationseinheit.id
						}`"
						variant="solid"
					>
						Details
					</nk-button>
				</nk-col>
			</nk-row>
			<nk-wrapper
				v-if="
					organisationseinheit.anschriften ||
					organisationseinheit.oeffnungszeiten
				"
			>
				<nk-row vertical-gutter="2" gutter="2">
					<nk-col
						v-if="organisationseinheit.anschriften[0]"
						cols="full"
						md="auto"
					>
						<nk-title size="lg">Adresse</nk-title>
						<nk-address
							variant="vertical"
							:strasse="`${organisationseinheit.anschriften[0].strasse} ${organisationseinheit.anschriften[0].hausnummer}`"
							:plz="organisationseinheit.anschriften[0].postleitzahl"
							:ort="organisationseinheit.anschriften[0].ort"
						/>
					</nk-col>
					<nk-col
						v-if="organisationseinheit.oeffnungszeiten.text.length > 0"
						cols="full"
						md="auto"
					>
						<nk-title size="lg">Öffnungszeiten</nk-title>
						<div
							class="nk-cms-content"
							v-html="organisationseinheit.oeffnungszeiten.text"
						/>
					</nk-col>
				</nk-row>
			</nk-wrapper>
			<nk-row vertical-gutter="2" gutter="2">
				<nk-col
					v-for="(
						mitarbeiter, mitarbeiterIndex
					) in organisationseinheit.kontaktpersonen"
					:key="`mitarbeiter-${mitarbeiterIndex}`"
					cols="full"
					sm="6/12"
					xl="4/12"
				>
					<nk-card variant="boxed" :grouped="false">
						<template #header>
							<nk-link
								block
								:link="`${
									context.taggingpfadMitarbeiter.slice(-1) !== '/'
										? context.taggingpfadMitarbeiter + '/'
										: context.taggingpfadMitarbeiter
								}${
									$slugify(mitarbeiter.vorname + '-' + mitarbeiter.nachname) +
									'-id_' +
									mitarbeiter.id
								}`"
							>
								<nk-title tag="h3" size="md" no-margin>
									{{ mitarbeiter.vorname }}
									{{ mitarbeiter.nachname }}
								</nk-title>
							</nk-link>
							<div v-html="mitarbeiter.funktion" />
						</template>
						<template
							v-if="
								(console.log(
									'kommunikationsmoeglichkeiten:',
									mitarbeiter.kommunikationsmoeglichkeiten,
								),
								mitarbeiter.kommunikationsmoeglichkeiten?.length)
							"
							#body
						>
							<nk-address
								variant="vertical"
								:telefonnummern="
									mitarbeiter.kommunikationsmoeglichkeiten
										.filter(kontaktArt => kontaktArt.kanal === 'TELEFON')
										.map(telefon => {
											return {
												telefon: telefon.kennung,
												zusatz: telefon.kennungszusatz,
											};
										})
								"
								:email="
									mitarbeiter.kommunikationsmoeglichkeiten &&
									mitarbeiter.kommunikationsmoeglichkeiten.find(
										kontaktArt => kontaktArt.kanal === 'EMAIL',
									)
										? mitarbeiter.kommunikationsmoeglichkeiten.find(
												kontaktArt => kontaktArt.kanal === 'EMAIL',
											).kennung
										: null
								"
								:mobil="
									mitarbeiter.kommunikationsmoeglichkeiten &&
									mitarbeiter.kommunikationsmoeglichkeiten.find(
										kontaktArt => kontaktArt.kanal === 'MOBILTELEFON',
									)
										? mitarbeiter.kommunikationsmoeglichkeiten.find(
												kontaktArt => kontaktArt.kanal === 'MOBILTELEFON',
											).kennung
										: null
								"
							/>
						</template>
					</nk-card>
				</nk-col>
			</nk-row>
			<nk-wrapper
				v-if="
					(organisationseinheit.untergeordneteOrganisationseinheiten &&
						organisationseinheit.untergeordneteOrganisationseinheiten.length) ||
					(organisationseinheit.untergeordneteOEs &&
						organisationseinheit.untergeordneteOEs.length)
				"
				spacing="lg"
			>
				<nk-title size="lg">Untergeordnete Fachbereiche</nk-title>
				<nk-template-service-bw-organisationseinheiten
					:nesting-level="nestingLevel + 1"
					:options="options"
					:context="{
						taggingpfad: context.taggingpfad,
						taggingpfadMitarbeiter: context.taggingpfadMitarbeiter,
						organisationseinheiten:
							organisationseinheit.untergeordneteOEs ||
							organisationseinheit.untergeordneteOrganisationseinheiten,
					}"
				/>
			</nk-wrapper>
		</nk-accordion>
	</nk-wrapper>
</template>

<script>
import TemplatesDefault from '#nk/mixins/templates-default';

/**
 * @prop {string} context.titel
 * @prop {array} context.organisationseinheiten
 * @prop {string} context.taggingpfad
 * @prop {string} context.taggingpfadMitarbeiter
 */
export default {
	name: 'NkTemplateServiceBwOrganisationseinheiten',

	mixins: [TemplatesDefault],

	props: {
		nestingLevel: {
			type: Number,
			required: false,
			default: 0,
		},
	},

	methods: {
		openAccordion(index) {
			if (this.options && typeof this.options.openAccordion !== 'undefined') {
				if (typeof this.options.openAccordion === 'boolean') {
					return this.options.openAccordion;
				}

				if (Number.isInteger(this.options.openAccordion)) {
					return this.options.openAccordion === index;
				}
			}
			return this.context.length === 1;
		},
	},
};
</script>
